import { AiFillStar } from "react-icons/ai";
import { ReviewLogo, MiniLogo, ReviewRightSide, RightSideTop, StarsHolder, StarSpan, StarFlexer, StarContainer, RatingHolder } from "../styles/LPStyles";

const ReviewsBadge = () => {

    return (
        <>
         <ReviewLogo>
                      <MiniLogo src={"/images/lp/miniLogo.svg"} alt="Zonado Logo" />
                    </ReviewLogo>

                    <ReviewRightSide>
                      <RightSideTop>Zonado's Reviews</RightSideTop>
                      <StarsHolder>
                        <StarSpan>
                          <StarFlexer>
                            {[...Array(5)].map((e, i) => (
                              <StarContainer key={i}>
                                <AiFillStar color="#f2962d" size="16px" />
                              </StarContainer>
                            ))}
                          </StarFlexer>
                        </StarSpan>
                        <RatingHolder>(5.0)</RatingHolder>
                      </StarsHolder>
                    </ReviewRightSide>    
        </>
    )
};

export default ReviewsBadge;
